/*
 * @Description: 文章管理
 * @Author: yy
 * @LastEditors: yy
 * @Date: 2019-02-11 14:37:10
 * @LastEditTime: 2021-04-01 11:11:32
 */

import React from 'react'
import withStyles from 'isomorphic-style-loader/lib/withStyles'
import qs from 'query-string'

// @ts-ignore
import s from './AdminArticle.css'
import classNames from 'classnames'
// @ts-ignore
import loaddingGif from './loading.gif'
import AdminBackNav from '../adminBackNav/adminBackNav'
import { updateBrandEmotion, deleteArticle, getArticleList, getReportKeyWorldArticle, doChangeMongoArticle } from '../../controller';
import TimeInput from '../../components/TimeInput/TimeInput';
import DBPagination from '../../components/DBPagination/DBPagination';
import BrandInput from '../../components/BrandInput/BrandInput';

const baseEmot = [{
  type: 1,
  class: '推荐'
}, {
  type: 2,
  class: '好感'
}, {
  type: 3,
  class: '中立'
}, {
  type: 4,
  class: '差评'
}, {
  type: 5,
  class: '反感'
}]
const baseRelatedType = [{
  type: 0,
  class: '非弱相关'
}, {
  type: 1,
  class: '弱相关'
}]
let emotMap = {}
let emotKeyVal = {}
baseEmot.forEach(item => {
  emotMap[item.class] = item.type
  emotKeyVal[item.type] = item.class
}); 


const platformList = [{
  type: 'wx',
  class: '微信'
}, {
  type: 'wb',
  class: '微博'
}, {
  type: 'zh',
  class: '知乎'
}, {
  type: 'tt',
  class: '头条'
// }, {
//   type: 'wk',
//   class: '悟空问答'
}, {
  type: 'article',
  class: '文章（包括微信、头条、新闻）'
}, {
  type: 'xq',
  class: '雪球短文本'
}, {
  type: 'plgt',
  class: '评论跟帖'
}]

{/* <option value="0">文章（包括微信、头条、新闻）</option>
<option value="1">雪球短文本</option>
<option value="3">评论跟帖</option> */}
const platformMap = {}
platformList.forEach(item => {
  platformMap[item.class] = item.type
})


const tableTit = [{
  name: '',
  render (data, index) {
    return index + 1
  }
}, {
  name: '平台',
  key: 'pltform',
  indexKey: 'pltform'
}, {
  name: '文章标题',
  key: 'tit',
  indexKey: 'tit',
  render: (data) => <a href={data.url} target='_blank'> {data.tit} </a>
}, {
  name: '阅读数',
  sort: true,
  key: 'readCount',
  indexKey: 'readCount',
}, {
  name: '转发数',
  sort: true,
  key: 'repostsCount',
  indexKey: 'repostsCount'
}, {
  name: '评论数',
  sort: true,
  key: 'commentsCount',
  indexKey: 'commentsCount',
}, {
  name: '点赞数',
  key: 'attitudesCount',
  indexKey: 'attitudesCount',
  sort: true
}, {
  name: '发布日期',
  key: 'date',
  indexKey: 'date',
  sort: true
}, {
  name: 'DB值',
  key: 'db',
  indexKey: 'db',
  sort: true
}, {
  name: '关联品牌&感情倾向',
  key: 'emotion',
  indexKey: 'emot',
  render: (data) => data.brandList.map((j, _i) => <span key={`${j.name}_${_i}`}> {j.name}:{j.emotion} </span>)
}, {
  name: '操作'
}]


const mongoTableTit = [{
  name: '',
  checkbox: true
}, {
  name: '',
  render (data, index) {
    return index + 1
  }
}, {
  name: '平台',
  key: 'pltform',
  indexKey: 'pltform'
}, {
  name: '文章标题',
  key: 'tit',
  indexKey: 'tit',
  render: (data) => <a href={data.url} target='_blank'> {data.tit} </a>
}, {
  name: '阅读数',
  sort: true,
  key: 'readCount',
  indexKey: 'readCount',
}, {
  name: '转发数',
  sort: true,
  key: 'repostsCount',
  indexKey: 'repostsCount'
}, {
  name: '评论数',
  sort: true,
  key: 'commentsCount',
  indexKey: 'commentsCount',
}, {
  name: '点赞数',
  key: 'attitudesCount',
  indexKey: 'attitudesCount',
  sort: true
}, {
  name: '发布日期',
  key: 'date',
  indexKey: 'date',
  sort: true
}, {
  name: 'DB值',
  key: 'db',
  indexKey: 'db',
  sort: true
}, {
  name: '相关性',
  key: 'related',
  indexKey: 'related_type',
  render: (data) => data.related_type == 1 ? '弱相关': '非弱相关'
}, {
  name: '关联品牌&感情倾向',
  key: 'emotion',
  indexKey: 'emot',
  render: (data) => data.brandList.map((j, _i) => <span key={`${j.name}_${_i}`}> {j.name}:{j.emotion} </span>)
}, {
  name: '操作'
}]

const sourceMap = {
  mysql: getArticleList,
  mongo: getReportKeyWorldArticle
}

const rinseData = (str) => (str === undefined || str === null) ? '无' : parseInt(str)

const valid = (params) => {
  if (params.brandName === '') {
    return alert("请填写品牌名称！")
  } else if (params.startDate === '') {
    return alert('请填写开始时间')
  } else if (params.statisDate === '') {
    return alert('请填写结束时间')
  }

  return true
}


class AdminArticle extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      brandName: '',
      industry: '',
      emotion: 0,
      nextEmotion: '',
      sourceEmotion: '',
      platform: 'wx',
      timeStartShow: false,
      timeEndShow: false,
      timeStart: '',
      timeEnd: '',
      tableData: [],
      kolType: 0,
      kol: '',
      loadding: false,
      source: 'mysql',
      keyWorld: '',
      current: 1,
      pageSize: 20,
      count: 0,
      sortIndex: null,

      // articleType: '0',
      correlation: '',
      checkList: []
    }
  }


  saveFile = () => {
    // 保存数据到本地
    const { brandName, industry, emotion, platform, timeStart, timeEnd, kolType, kol } = this.state

    if (!timeEnd || !timeStart) {
      alert('时间为必选')
    } else {
      const query = qs.stringify({
        brandName,
        industry,
        emotion
      }) 
      console.log(query);
      
      let url
      if (this.state.source === 'mysql') {
        url = `/dbrankCMS/saveArticleList?${query}&timeStart=${timeStart}&timeEnd=${timeEnd}&pltform=${platform}&kol=${kol}&kolType=${kolType}&page=0`
      } else {
        url = `/digitalAssets/report/getReportKeyWorldArticle?${query}&startTime=${timeStart}&statisTime=${timeEnd}&platform=${platform}&keyWorld=${this.state.keyWorld}&key=1`
      }
      // ==后台调试使用，禁止删除=====================
      console.info('下载地址：', url)
      const a = document.createElement('a');
      a.textContent = 'download';
      a.download = 'filename';
      a.href = url;
      a.click();
    }
  }

  saveToState = (e) => {
    const { name, value } = e.target
    this.setState({
      [name]: value
    })
  }

  getArticleList = (getCount = false) => {
    //获取文章列表
    const { brandName, industry, emotion, platform, timeStart, timeEnd, kolType, kol, correlation } = this.state

    if (!timeEnd || !timeStart) {
      alert('时间为必选')
    } else {
      this.setState({
        loadding: !getCount ? true : false,
        sourceEmotion: this.state.emotion
      })
      let params = {
        brandName,
        industry,
        emotion
      }

      if (this.state.source === 'mysql') {
        params = Object.assign(params, {
          pltform: platform,
          timeStart,
          timeEnd,
          page: 0
        })
      } else {
        params = Object.assign(params, {
          platform,
          getCount,
          startTime: timeStart,
          statisTime: timeEnd,
          keyWorld: this.state.keyWorld,
          relatedType: correlation
        })
      }


      sourceMap[this.state.source](params)
        .then(res => {
          this.setState({ loadding: false })

          if (res.errorCode == 2) {
            alert('请重新登录！')
            this.setState({ 
              tableData: [], 
              sortIndex: null,
              current: 1
            })
          } else {
            if (getCount) {
              this.setState({ 
                count: res[0].count || 0
              })
            } else {
              const list = this.filterData(res || [])
              this.setState({ 
                tableData: list,
                sortIndex: null,
                current: 1
              })
            }
          }
        })
    }
  }

  /**
   * 更改数据源
   * @param {*} event 
   */
  changeSource = (event) => {
    this.setState({
      source: event.target.value
    })
  }

  /**
   * 重新构造返回结果
   * @param {Array} list 
   */
  filterData (list) {

    const {brandName} = this.state

    return list.map(item => {
      // 阅读数
      item.readCount = rinseData(item.readCount)
      // 转发数
      item.repostsCount = rinseData(item.repostsCount)
      // 评论数
      item.commentsCount = rinseData(item.commentsCount)
      // 点赞数
      item.attitudesCount = rinseData(item.attitudesCount)
      
      // 情感倾向
      const emotBrand = item.brandList.find(i => {
        return i.name == brandName
      })
      if (emotBrand) {
        item.emot = emotMap[emotBrand.emotion]
      } else {
        item.emot = ''
      }
      return item;
    })
  }
  
  getBrandFullName = (brand) => {
    this.setState({ brandName: brand })
  }

  /**
   * 删除文章事件
   * @param {Number} index 
   */
  deleteArticle (index, data) {
    const bool = confirm('确认删除改数据？')
    const { source, tableData} = this.state

    if (!bool) return false
    
    if (source === 'mongo') {
      return this.editArticleFormAjax({
        key: 'delete',
        platform: platformMap[data.pltform],
        ids: data._id,
      }, () => {
        
        this.setState({
          tableData: tableData.filter(item => item._id !== data._id)
        })
      })
    }


    this.ajaxDeleteArticle(null, data, () => {
      this.setState({
        tableData: tableData.filter(item => item._id !== data._id)
      })
      alert('删除成功!')
    })
  }

  /**
   * 删除文章接口
   * @param {Object} item 
   * @param {Function} fn 
   */
  ajaxDeleteArticle (val, item, fn) {
    const {brandName} = this.state
    deleteArticle({
      brand_name: brandName,
      url: item.url,
      platform: platformMap[item.pltform] || item.pltform,
      statisDate: item.date,
    })
      .then(res => {
        if (!res.incomplete_results) {
          typeof fn === 'function' && fn()
        } else {
          alert('删除文章失败！')
        }
      })
  }


  /**
   * 修改情感倾向事件
   * @param {*|Event} event 
   * @param {Number} index 
   */
  changeEmotional = (event, index, data) => {
    const bool = confirm('确认修改情感倾向？')
    if (!bool) return

    const {tableData, brandName, source} = this.state
    const val = event.target.value

    const fn = source === 'mongo' ? this.changeEmotionalOfMongo : this.ajaxChangeEmotion
    fn(val, data, () => {
      tableData.forEach(item => {
        if (item._id === data._id) {
          item.emot = val
          item.brandList.forEach(_i => {
            if (brandName === _i.name) {
              _i.emotion = emotKeyVal[val]
            }
          })
        }
      })

      this.setState({
        tableData
      })
    })
  }

  /**
   * 修改情感倾向接口 mysql
   * @param {Object} item 
   * @param {Function} fn 
   */
  ajaxChangeEmotion (val, item, fn) {
    // doChangeMongoArticle
    updateBrandEmotion({
      url: item.url,
      platform: platformMap[item.pltform] || item.pltform,
      statisDate: item.date,
      brand_id: item.brandId,
      emotion: val
    })
      .then(res => {
        if (res.incomplete_results) {
          alert('修改情感倾向失败！')
        } else {
          typeof fn === 'function' && fn()
        }
      })
  }


  // 修改单条好感度-mongo库
  changeEmotionalOfMongo = (val, data, fn) => {
    this.editArticleFormAjax({
      key: 'updateEmotion',
      ids: data._id,
      platform: platformMap[data.pltform],
      value: val,
    }, fn)
  }

 /**
   * 批量删除文章--已废弃
   * @memberof Article
   */
  deleteArticleAll = () => {
    const bool = confirm('将删除mysql和mongo的选中数据')
    
    if (!bool) {
      return false
    }

    const params = {
      brandName: this.state.brandName,
      startDate: this.state.timeStart,
      statisDate: this.state.timeEnd,
      key: 'delete',
      keyInfo: this.state.emotion,
      platform: this.state.platform
    }

    if (this.state.source === 'mongo') {
      params['keyWorld'] = this.state.keyWorld
    }

    doChangeMongoArticle(params)
      .then(res => {
        this.setState({
          loadding: false
        })

        if (res.errCode == 0) {
          alert("删除成功！")
        } else {
          alert("删除失败！")
        }
      })
  }

  // 批量删除文章
  deleteArticleAllForIds = () => {
    const bool = confirm('确定删除选中数据')
    if (!bool) return false
    const { platform, checkList, tableData } = this.state

    this.editArticleFormAjax({
      key: 'delete',
      platform: platform,
      ids: checkList.join(',')
    }, () => {
      this.setState({
        tableData: tableData.filter(ele => !checkList.includes(ele._id)),
        checkList: []
      })
    })
  }

  // updateRelatedType、updateEmotion
  // 批量修改相关性和好感度
  editArticleAttr = (type = 'updateRelatedType', e) => {
    const { checkList, platform, tableData } = this.state
    
    const _val = e.target.value
    if (_val === '') return false
    const val = parseInt(_val)

    const bool = confirm('确定修改选中数据')
    if (!bool) return false
  
    this.editArticleFormAjax({
      key: type,
      platform: platform,
      ids: checkList.join(','),
      value: val,
    }, (res) => {
      tableData.forEach(ele => {
        if (checkList.includes(ele._id)) {
          ele[type === 'updateRelatedType' ? 'related_type' : 'emot'] = val
        }
      })
      this.setState({
        tableData,
        checkList: []
      })
    })
  }

  // 编辑文章数据统一接口
  editArticleFormAjax = ({key, platform, ids, value = ''}, fn) => {
    const { timeStart, timeEnd } = this.state
    const params = {
      key: key,
      platform: platform,
      ids: ids,
      value: value,
      // 数据库分片需要增加时间区间
      startTime: timeStart,
      statisTime: timeEnd,
    }
    this.setState({ loading: true })
    doChangeMongoArticle(params)
      .then(res => {
        this.setState({ loadding: false })
        if (res.code === 200) {
          alert(key === 'delete' ? '删除成功！' : "修改成功！")
          typeof fn === 'function' && fn(res)
        } else {
          alert(key === 'delete' ? '删除失败！' : "修改失败！")
        }
      })
  }

  /**
   * 批量修改好感度--废弃
   * @memberof Article
   */
  changeLoveAll = () => {
    const bool = confirm('将批量修改mongo的好感度')
    
    if (!bool) {
      return false
    }

    const { nextEmotion, platform, tableData, timeStart, timeEnd } = this.state
    const params = {
      key: 'updateEmotion', 
      platform: platform,
      ids: tableData.map(v => v._id).join(','),
      value: nextEmotion,
      startTime: timeStart,
      statisTime: timeEnd,
    }

    doChangeMongoArticle(params)
      .then((res) => {
        if (res.code === 200) {
          alert("修改成功!")
          // 重新加载数据
          this.getArticleList()
        } else {
          alert("修改失败！")
        }
      })
  }


  renderKeyWord () {
    if (this.state.source ==='mongo') {
      return (
        <div style={{display: 'inline-block'}}>
          <label className={s.label}>关键词：</label>
          <input className={s.input} type="text" value={this.state.keyWorld} onChange={(e) => this.setState({keyWorld: e.target.value})} />
        </div>
      )
    }

    return null
  }

  /**
   * 文章管理表单
   */
  renderForm () {
    const { industry, timeStart, timeEnd, emotion, nextEmotion, platform, brandName, correlation } = this.state

    return (
      <div className={s.listBox}>
        <div>
          <label className={s.label}>品牌名称：</label>
          <BrandInput value={brandName} onChange={this.getBrandFullName} className={s.input} />
          
          <label className={s.label}>行业：</label>
          <input className={s.input} type='text' value={industry} name='industry' onChange={this.saveToState} />
          
          <label className={s.label}>数据来源：</label>
          <select className={s.select} value={this.state.source} onChange={this.changeSource}>
            <option value="mysql">mysql</option>
            <option value="mongo">mongo</option>
          </select>
          
          {this.renderKeyWord()}
        </div>
        
        <hr/>
        
        <div>
          <label className={s.label}>开始时间：</label>
          <TimeInput className={s.input} value={timeStart} onChange={e => this.setState({timeStart: e})} />
          
          <label className={s.label}>结束时间：</label>
          <TimeInput className={s.input} value={timeEnd} onChange={e => this.setState({timeEnd: e})} />

          <label className={s.label}>感情倾向：</label>
          <select className={s.select} onChange={(e) => this.setState({ emotion: e.target.value })} value={emotion}>
            <option value="0">不选择</option>
            {baseEmot.map(i => <option key={i.type} value={i.type}>{i.class}</option> )}
          </select>

          <label className={s.label}>平台：</label>
          <select className={s.select} onChange={(e) => this.setState({ platform: e.target.value })} value={platform}>
            {platformList.map(i => <option key={i.type} value={i.type}>{i.class}</option> )}
          </select>
        </div>
        
        <hr/>

        <div style={{display: 'flex'}}>
          <div> 
            <label className={s.label}>相关性：</label>
            <select 
              className={s.select} 
              onChange={(e) => this.setState({ correlation: e.target.value })} 
              value={correlation}
            >
              <option value="">全部</option>
              <option value="0">非弱相关</option>
              <option value="1">弱相关</option>
            </select>
          </div>
        </div>
        
        {this.state.source === 'mongo' && <hr/>}

        <div style={{display: 'flex'}}>
          {this.state.source === 'mongo' ? 
            <div className={s.btnGroup}>
              <label className={s.label}>批量修改成：</label> 
              <select className={s.select} onChange={(e) => this.setState({ nextEmotion: e.target.value })} value={nextEmotion}>
                <option value="0">不选择</option>
                {baseEmot.map(i => <option key={i.type} value={i.type}>{i.class}</option> )}
              </select>

              <button style={{
                marginLeft: '20px'
              }} onClick={this.changeLoveAll} className={classNames(s.btn, s.danger)}>批量修改好感度</button>
              <strong >mongo查询文章每次最多返回8000条，<br/>如果超过8000条请进一步缩小搜索范围或者联系技术人员</strong>
            </div>
            : null 
          }
        </div>

        <hr/>

        <div className={s.btnGroup} style={{paddingLeft: '100px'}}>
          <button onClick={() => this.getArticleList()} className={s.btn}>搜索</button>
          <button onClick={this.saveFile} className={s.btn}>点击导出数据</button>
          
          {this.state.source === 'mongo' ? (
            <div style={{display: 'flex'}}>
              <button onClick={() => this.getArticleList(true)} className={s.btn}>获取总条数</button>
              <span>{`共有${this.state.count}条数据`}</span>  
              {/* <button onClick={this.deleteArticleAll} className={classNames(s.btn, s.danger)}>批量删除</button>  */}
            </div>
          ): null}

        </div>

        <hr />
        {this.state.source === 'mongo' ? (
          <div className={s.btnGroup} style={{paddingLeft: '100px'}}>
            <div style={{display: 'flex'}}>
              <hr />
              <button disabled={this.state.checkList.length === 0} onClick={this.deleteArticleAllForIds} className={classNames(s.btn, s.danger)}>删除选中</button> 
              <label style={{marginRight: 15}}>
                <span>修改选中好感度:</span>
                <select disabled={this.state.checkList.length === 0} className={s.select} onChange={e => this.editArticleAttr('updateEmotion', e)}>
                  <option value=""> 请选择 </option>
                  {baseEmot.map(item => (
                    <option value={item.type} key={item.type}> {item.class} </option>
                  ))}
                </select>
              </label>
              <label>
                <span>修改选中相关性:</span>
                <select disabled={this.state.checkList.length === 0} className={s.select} onChange={e => this.editArticleAttr('updateRelatedType', e)}>
                  <option value=""> 请选择 </option>
                  {baseRelatedType.map(item => (
                    <option value={item.type} key={item.type}> {item.class} </option>
                  ))}
                </select>
              </label>
            </div>
          </div>
        ): null}
      </div>
    )
  }

  // 操作
  renderHandle = (value, index) => {
    return (
      <div className={s.tableBtnGroup}>
        <select className={s.select} onChange={e => this.changeEmotional(e, index, value)} value={value.emot}>
          {baseEmot.map(item => <option value={item.type} key={item.type}> {item.class} </option> )}
        </select> | <button className={classNames(s.btn, s.danger)} onClick={e => this.deleteArticle(index, value)}>删除</button>
      </div>
    )
  }


  /**
   * 排序
   * @param {*} item 
   * @param {*} index 
   */
  sortList = (item, index) => {
    if (item.sort) {
      const {tableData} = this.state
      
      this.setState({
        sortIndex: index,
        tableData: tableData.slice(0).sort((a, b) => {
          if (typeof b[item.key] === 'number') {
            return b[item.key] - a[item.key]
          } 

          if (b[item.key] < a[item.key]) {
            return -1
          }
          return 1
        })
      })

    }
  }

  // 多选
  onChangeCheckList = (val) => {
    const { checkList } = this.state
    const index = checkList.indexOf(val)
    if (index >= 0) {
      checkList.splice(index, 1)
    } else {
      checkList.push(val)
    }
    this.setState({checkList})
  }

  // 编辑相关性
  editRelatedType = (e, data) => {
    const { timeStart, timeEnd } = this.state
    const type = e.target.value - 0
    const bool = confirm('确定修改相关性')
    if (!bool) {
      return false
    }
    
    const params = {
      key: 'updateRelatedType',
      platform: this.state.platform,
      value: type,
      ids: data._id,
      startTime: timeStart,
      statisTime: timeEnd,
    }
  
    doChangeMongoArticle(params).then(res => {
      this.setState({
        loadding: false
      })

      if (res.code == 200) {
        alert("修改成功！")
        const {tableData} = this.state
        const index = tableData.findIndex(ele => data._id === ele._id)
        if (index >= 0) {
          tableData[index].related_type = type
        }

        this.setState({tableData})
      } else {
        alert("修改失败！")
      }
    })
  }

  renderRelatedType = (data) => {
    return <select className={s.select} style={{width: 90}} onChange={e => this.editRelatedType(e, data)} value={data.related_type}>
      {baseRelatedType.map(i => <option key={i.type} value={i.type}>{i.class}</option> )}
    </select>
  }

  // 渲染行
  renderTr (data, index) {
    const { source, checkList } = this.state
    let titles = tableTit
    if (source === 'mongo') {
      titles = mongoTableTit
      titles[0].render = (data) => {
        return <span onClick={() => this.onChangeCheckList(data._id)} className={classNames(s.checkBox, {
          [s.checked]: checkList.includes(data._id)
        })} />
      }
      titles[10].render = this.renderRelatedType
    }
    return (
      <tr>
        {titles.map((ele, _i) => <td key={`${index}_${_i}`}>{ ele.render ? ele.render(data, index) : data[ele.indexKey] }</td>)}
      </tr>
    )
  }

  selectAllToggle = () => {
    const { tableData, checkList, current, pageSize } = this.state
    // 全选时候只选中当前页面
    // 如果当前页面没有选择或部分选中，则选中当前页面所有，删除当前页选中的

    const currentList = tableData.slice((current - 1) * pageSize, pageSize * current)
    const currentListIds = currentList.map(item => item._id)
    const intersection = checkList.filter(v => currentListIds.includes(v))


    // 如果选中了当前页面所有数据则从列表中删除当前页面数据
    if (currentListIds.length === intersection.length) {
      this.setState({
        checkList: checkList.filter(v => !currentListIds.includes(v))
      })
    } else {
      this.setState({
        checkList: Array.from(new Set(currentListIds.concat(checkList)))
      })
    }
  }

  /**
   * 列表
   */
  renderTable () {
    const { tableData, current, pageSize, sortIndex, source, checkList } = this.state

    const titles = source === 'mongo' ? mongoTableTit : tableTit

    titles[titles.length - 1].render = this.renderHandle
    const list = tableData.slice((current - 1) * pageSize, pageSize * current)
    const currentListIds = list.map(d => d._id)
    // 当前页面数据 和 选中列表交集，最长为当前页的长度
    const intersection = checkList.filter(v => currentListIds.includes(v))

    return (
      <div>
        <table className={s.table} cellSpacing="0" cellPadding="0">
          <thead>
            <tr>
              {titles.map((i, index) => {
                if(i.checkbox) {
                  return <th key={index}><span className={classNames(s.checkBox, {
                    [s.checked]: currentListIds.length === intersection.length,
                    [s.indeterminate]: intersection.length > 0 && currentListIds.length != intersection.length 
                  })} onClick={this.selectAllToggle} /></th>
                }
                return <th onClick={() => this.sortList(i, index)} className={index ===sortIndex ? s.active : ''} key={index}>{i.name}</th>
              })}
            </tr>
          </thead>
          <tbody>
            {list.map((data, index) => this.renderTr(data, index))}
          </tbody>
        </table>
      </div>
      
    )
  }


  render() {
    const { loadding, tableData } = this.state
    const listTotal = tableData.length


    return (
      <div className={s.root}>
        <AdminBackNav />

        <div className={s.container}>
          <h1>文章管理</h1>
          {this.renderForm()}

          <br/>

          <div className={s.tableBox}>
            {loadding && <div className={s.loadingMark}><img src={loaddingGif} /></div>}

            {this.renderTable()}

            <DBPagination total={listTotal} pageSize={this.state.pageSize} current={this.state.current} pageChange={obj => {
              this.setState({
                current: obj.current,
                pageSize: obj.pageSize
              })
            }} />
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(AdminArticle);



// WEBPACK FOOTER //
// src/routes/adminArticle/AdminArticle.js